import { render, staticRenderFns } from "./Dialog2.vue?vue&type=template&id=739cfe20&scoped=true&"
import script from "./Dialog2.vue?vue&type=script&lang=js&"
export * from "./Dialog2.vue?vue&type=script&lang=js&"
import style0 from "./Dialog2.vue?vue&type=style&index=0&id=739cfe20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739cfe20",
  null
  
)

export default component.exports